
export default {
  props: ["imageName", "altText", "ctaButtonTitle"],
  computed: {
    imagePaths: function () {
      const mainDir = "/assets/imgs/";
      return {
        mobile: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}-mobile${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
        desktop: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
      };
    },
  },
};
